<template>
  <div class="tw-mb-6">
    <span>{{ $t(i18n) }}</span>
    <div v-if="breadcrumb.length > 0" class="tw-flex tw-flex-wrap tw-mt-2">
      <span v-for="(item, position) in breadcrumb" :key="item.id">
        <span v-if="position > 0" class="tw-mx-2">&rsaquo;</span>
        <span class="tw-cursor-pointer tw-text-blue-700 hover:tw-text-red-700" @click="back(item.parent, position)">
          {{ item.name }}
        </span>
      </span>
    </div>
    <v-select
      v-if="!empty"
      ref="select"
      :items="categories"
      item-text="name"
      item-value="id"
      :value="this.category"
      @change="swap"
    >
      <template #item="{item}">
        <span class="tw-text-xs">
          {{ item.name }}
        </span>
      </template>
      <template v-for="slot in Object.keys($slots)" v-slot:[slot]>
        <slot :name="slot"></slot>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: "CategoriesField",
  props: {
    category: { required: true },
  },
  data: () => ({
    i18n: "registration.form.company.category",
    empty: true,
    firstChange: true,
    breadcrumb: [],
    categories: [],
  }),
  async mounted() {
    await this.loadByLevel(1)
    await this.loadBreadcrumb()
  },
  watch: {
    category(category_id) {
      if (category_id === null) {
        return
      }

      if(this.firstChange === true){
        this.loadBreadcrumb()
        this.firstChange = false
      }

      const selectedCategory = this.categories.filter(category => category.id === category_id)

      if (!Array.isArray(selectedCategory) || selectedCategory.length <= 0) {
        return
      }

      this.breadcrumb.push(...selectedCategory)

      this.loadById(category_id)
      this.openSelectMenu()
    },
  },
  methods: {
    back(parent, position) {
      if(position === 0){
        this.loadByLevel(1)
      }else{
        this.loadById(parent)
      }
      this.breadcrumb = this.breadcrumb.slice(0, position)
      this.$emit("update:category", null)

      this.openSelectMenu()
    },
    swap(category_id) {
      this.$emit("update:category", category_id)
    },
    loadById(category_id) {
      this.empty = false
      this.$axios.get("/office/common/categories/id/" + category_id).then(response => {
        this.categories = response.data.data
        this.empty = this.categories.length <= 0
      })
    },
    async loadByLevel(level) {
      return new Promise((resolve, reject) => {
        this.empty = false
        this.$axios
          .get("/office/common/categories/level/" + level)
          .then(response => {
            this.categories = response.data.data
            this.empty = this.categories.length <= 0
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },
    loadBreadcrumb() {
      this.empty = false
      this.$axios.get("/office/common/categories/breadcrumb?category_id=" + this.category).then(response => {
        this.breadcrumb = response.data.data
        if (this.breadcrumb.length > 0) {
          this.empty = true
        }
      })
    },
    async openSelectMenu() {
      await this.$nextTick()
      this.$refs.select.focus()
      this.$refs.select.isMenuActive = true
    },
  },
}
</script>
